// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --sandbox-banner-height: 44px;
}

.sandbox-banner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: var(--sandbox-banner-height);
    z-index: 10000;
    background: linear-gradient(135deg, #ff6b35 0%, #f7931e 100%);
    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
    animation: pulse-glow 2s ease-in-out infinite;
}

.sandbox-banner-content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 20px;
    gap: 12px;
}

.sandbox-icon {
    font-size: 20px;
    animation: bounce 1s ease-in-out infinite;
}

.sandbox-text {
    color: white;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.sandbox-text strong {
    font-weight: 700;
    font-size: 15px;
}

@keyframes pulse-glow {

    0%,
    100% {
        box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
    }

    50% {
        box-shadow: 0 4px 20px rgba(255, 107, 53, 0.7);
    }
}

@keyframes bounce {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-3px);
    }
}

/* Body padding removed - fixed layouts handle their own offsets */
/* Keep shared modals (AppModal) below the fixed sandbox banner */
body.sandbox-mode .app-modal-overlay {
    top: var(--sandbox-banner-height);
}
`, "",{"version":3,"sources":["webpack://./src/components/SandboxBanner.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,oCAAoC;IACpC,cAAc;IACd,6DAA6D;IAC7D,8CAA8C;IAC9C,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI;;QAEI,8CAA8C;IAClD;;IAEA;QACI,8CAA8C;IAClD;AACJ;;AAEA;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA,kEAAkE;AAClE,iEAAiE;AACjE;IACI,iCAAiC;AACrC","sourcesContent":[":root {\n    --sandbox-banner-height: 44px;\n}\n\n.sandbox-banner {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: var(--sandbox-banner-height);\n    z-index: 10000;\n    background: linear-gradient(135deg, #ff6b35 0%, #f7931e 100%);\n    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);\n    animation: pulse-glow 2s ease-in-out infinite;\n}\n\n.sandbox-banner-content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px 20px;\n    gap: 12px;\n}\n\n.sandbox-icon {\n    font-size: 20px;\n    animation: bounce 1s ease-in-out infinite;\n}\n\n.sandbox-text {\n    color: white;\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.sandbox-text strong {\n    font-weight: 700;\n    font-size: 15px;\n}\n\n@keyframes pulse-glow {\n\n    0%,\n    100% {\n        box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);\n    }\n\n    50% {\n        box-shadow: 0 4px 20px rgba(255, 107, 53, 0.7);\n    }\n}\n\n@keyframes bounce {\n\n    0%,\n    100% {\n        transform: translateY(0);\n    }\n\n    50% {\n        transform: translateY(-3px);\n    }\n}\n\n/* Body padding removed - fixed layouts handle their own offsets */\n/* Keep shared modals (AppModal) below the fixed sandbox banner */\nbody.sandbox-mode .app-modal-overlay {\n    top: var(--sandbox-banner-height);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
